export var ObjectsHeaderActions;
(function (ObjectsHeaderActions) {
    ObjectsHeaderActions["ADD"] = "add";
})(ObjectsHeaderActions || (ObjectsHeaderActions = {}));
